import { graphql, Link } from 'gatsby'
import React from 'react'
import get from 'lodash/get'

import Meta from 'components/meta'
import Layout from 'components/layout'

class BlogPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      blogs: get(this.props.data, 'allContentfulBlogs.nodes'),
      filteredBlogs: get(this.props.data, 'allContentfulBlogs.nodes'),
      search: '',
    }
  }

  renderBlog = (blog, index) => {
    return (
      <div className="row recent-post py-2 mx-0" key={index}>
        <div className="recent-post-thumb col px-0">
          <Link to={'/blog/' + blog.slug}>
            <img
              src={blog.image ? blog.image.file.url : ''}
              alt="no-image"
              width="90"
              height="60"
            />
          </Link>
        </div>
        <div className="recent-post-thumb-content col px-2 d-flex flex-column align-items-start justify-content-center">
          <h5 className="m-0 pd-1"> <Link to={'/blog/' + blog.slug}>{blog.title}</Link></h5>
          <span className="post-time m-0">by : {blog.author}</span>
        </div>
      </div>
    )
  }

  onchange = e => {
    this.setState({ search: e.target.value })
  }

  render() {
    const { location, data } = this.props
    const { blogs, search } = this.state
    const filteredBlogs = blogs.filter(item => {
      return (item.title.toLowerCase().indexOf(search.toLowerCase()) !== -1 || item.shortDescription.shortDescription.toLowerCase().indexOf(search.toLowerCase()) !== -1)
    })
    return (
      <Layout location={location}>
        <Meta
          site={get(data, 'contentfulPagesSeo')}
        />
        <div className="wrapper inner-page">
          <div className="boxed1 conactUs-banner-wrapper">
            <div
              className="page-banner masked parallax-inner parallax-section blog-bnr-title"
              data-parallax="1"
            >
              <div className="inner-continer d-flex align-items-center justify-content-center">
                <div className="row">
                  <div className="col-md-12 pd-0">
                    <h1 className="display-1 text-white text-center mb-0">
                      Blog
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="empty-space col-xs-b35 col-md-b70"></div>

          <div className="page-content mt-0 cus-contact-location">
            <section className="page-contact blog-page-content">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    {blogs.map((item, index) => {
                      return (
                        <div
                          className="blog-info mb-4 d-inline-block"
                          key={index}
                        >
                          <Link to={'/blog/' + item.slug}>
                            <img
                              src={item.image ? item.image.file.url : ''}
                              alt="no-image"
                            />
                          </Link>

                          <div className="blog-post">
                            <h4 className="sub-heading mt-0">
                              <Link to={'/blog/' + item.slug}>
                                {item.title}
                              </Link>
                            </h4>
                            <div className="row mx-0 d-flex justify-content-between mb-2">
                              <div className="timer">
                                <i
                                  className="fa fa-calendar lightgrey-color"
                                  aria-hidden="true"
                                ></i>
                                <small className="pl-2 pr-4">
                                  {item.updatedAt}
                                </small>
                                <i
                                  className="fa fa-clock-o lightgrey-color"
                                  aria-hidden="true"
                                ></i>
                                <small className="pl-2">{item.time}</small>
                              </div>
                              <div className="social-icon text-right">
                                <a
                                  className="px-2 lightgrey-color"
                                  target="_blank"
                                  href={
                                    'https://www.facebook.com/sharer/sharer.php?u=' +
                                    location.origin +
                                    '/blog/' +
                                    item.slug
                                  }
                                >
                                  <i className="fa fa-facebook-f"></i>
                                </a>
                                <a
                                  className="px-2 lightgrey-color"
                                  target="_blank"
                                  href={
                                    'https://twitter.com/intent/tweet?text=' +
                                    item.title +
                                    '&url=' +
                                    location.origin +
                                    '/blog/' +
                                    item.slug
                                  }
                                >
                                  <i className="fa fa-twitter"></i>
                                </a>
                              </div>
                            </div>
                            <div className="blog-desc mb-4">
                              <p>{item.shortDescription.shortDescription}</p>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>

                  <div className="col-md-1 col-md-cus-1"></div>

                  <div className="col-md-3 blog-sideBar">
                    <div className="sidebar">
                      <div className="search-bar mb-4">
                        <div className="input-group recent-search mb-3">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <i
                                className="fa fa-search"
                                aria-hidden="true"
                              ></i>
                            </span>
                          </div>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search.."
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            onChange={this.onchange}
                          />
                        </div>
                      </div>
                      <h4 className="sub-heading recent-post-title pt-3 mb-1">
                        Recent Posts
                      </h4>
                      <div className="recent-post-thumbnail mr-0 w-100">
                        {filteredBlogs.map((item, index) => {
                          if (index < 3) {
                            return this.renderBlog(item, index)
                          }
                        })}
                      </div>

                      <div className="follow-us mt-3 d-inline-block">
                        <h4 className="sub-heading">Follow Us</h4>

                        <div className="social-list">
                          <a
                            href="https://www.facebook.com/goinfinityenergy"
                            target="_blank"
                            className="icon ion-social-facebook lightgrey-color"
                            rel="noopener"
                            aria-label="ion-social-facebook"
                          ></a>
                          <a
                            href="https://www.instagram.com/infinityenergy/?hl=en"
                            target="_blank"
                            className="icon ion-social-instagram lightgrey-color"
                            rel="noopener"
                            aria-label="ion-social-instagram"
                          ></a>
                          <a
                            href="https://www.linkedin.com/company/infinity-energy-inc"
                            target="_blank"
                            className="icon ion-social-linkedin lightgrey-color"
                            rel="noopener"
                            aria-label="ion-social-linkedin"
                          ></a>
                          <a
                            href="https://www.youtube.com/channel/UCwOtFB9REiYAIU7hPRnq5iA"
                            target="_blank"
                            className="icon ion-social-youtube lightgrey-color"
                            rel="noopener"
                            aria-label="ion-social-youtube"
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="empty-space col-xs-b35 col-md-b70"></div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default BlogPage

export const query = graphql`
  {
    allContentfulBlogs(sort: { fields: createdAt, order: DESC }) {
      nodes {
        tag
        title
        slug
        shortDescription {
          shortDescription
        }
        longDescription {
          longDescription
        }
        image {
          file {
            url
          }
        }
        author
        updatedAt(formatString: "MMM Do YY")
        time: updatedAt(formatString: "h:mm:ss a")
        id
      }
    }
    contentfulPagesSeo(pageName: {eq: "Blogs"}) {
      pageTitle
      pageName
      otherScripts {
        otherScripts
      }
      otherMetaTags {
        otherMetaTags
      }
      metaTagUrl
      metaTagTitle
      metaTagDescription
    }
  }
`
